import { Component, Input } from '@angular/core';
import {DateRangeModel} from '../../../models/common/date.range';

@Component({
    selector: 'date-range-description',
    template: '<small *ngIf="!model.startDate && !model.endDate">No filter set</small><small *ngIf="model.startDate && model.endDate"> Between {{model.startDate | momentFormat}} and {{model.endDate | momentFormat}}</small><small *ngIf="model.startDate && !model.endDate">After {{model.startDate | momentFormat}}</small><small *ngIf="!model.startDate && model.endDate">Before {{model.endDate | momentFormat}}</small>'
})
export class DateRangeDescriptionComponent {
    @Input() model: DateRangeModel;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/date.range/date.range.description.component.ts